import * as _ from 'lodash';
import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Notification, NotificationJSON} from './notification';
import {ApiResponse, AuthService, BaseService} from '@hassel-it/angular-common';

@Injectable()
export class NotificationsService extends BaseService {

    constructor(public http: HttpClient, public authService: AuthService) {
        super(http, authService);
    }

    getNotifications(page: number = 1): Promise<ApiResponse> {
        this.reloadHeaders();
        const params: HttpParams = new HttpParams().set('page', <any>page);

        return this.http.get(environment.apiBase + '/api/ten-four/notifications', {
            params: params,
            headers: this.httpHeaders
        }).toPromise().then((response: any) => {
            const results = _.chain(response.data).map((json: NotificationJSON): Notification => {
                return Notification.fromJSON(json);
            }).value();
            return new ApiResponse(results, response.pagination.count as number);
        }).catch(NotificationsService.handleError);
    }

    getUnreadNotificationsCount(): Promise<number> {
        this.reloadHeaders();
        return this.http.get(environment.apiBase + '/api/ten-four/notifications/unread-count', {
            headers: this.httpHeaders
        }).toPromise().then((response: any) => {
            return response.data as number;
        })
    }

    updateNotification(notification: Notification): Promise<Notification> {
        this.reloadHeaders();
        return this.http.patch(environment.apiBase + '/api/ten-four/notifications/' + notification.id, notification, {
            headers: this.httpHeaders
        }).toPromise().then((response: any) => {
            return Notification.fromJSON(response.data);
        }).catch(NotificationsService.handleError);
    }
}
